/*
 * Colorbar Try-On — theme app extension engine.
 * Loaded once per page (Shopify dedupes the "javascript" asset declared in the
 * block's schema) even when the "Colorbar Try-On" block is added more than
 * once, so this file discovers every instance itself instead of assuming a
 * single global root the way a hand-pasted snippet would.
 *
 * `FaceMesh` is a global injected by the MediaPipe script loaded on demand
 * in loadFaceMesh() below — it does not exist until that script runs.
 */
/* global FaceMesh */
(function () {
  window.__colorbarVTOLoadFaceMesh = window.__colorbarVTOLoadFaceMesh || function () {
    if (window.__colorbarVTOFaceMeshPromise) return window.__colorbarVTOFaceMeshPromise;

    var p = new Promise(function (resolve, reject) {
      if (typeof FaceMesh !== 'undefined') { resolve(); return; }
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh@0.4.1633559619/face_mesh.js';
      s.crossOrigin = 'anonymous';
      s.async = true;
      var to = setTimeout(function () { reject(new Error('timeout')); }, 25000);
      s.onload = function () {
        clearTimeout(to);
        if (typeof FaceMesh !== 'undefined') resolve();
        else reject(new Error('FaceMesh global missing'));
      };
      s.onerror = function () { clearTimeout(to); reject(new Error('network')); };
      document.head.appendChild(s);
    });

    // Drop the cached promise on failure so a retry can re-attempt the download.
    p['catch'](function () { window.__colorbarVTOFaceMeshPromise = null; });

    window.__colorbarVTOFaceMeshPromise = p;
    return p;
  };

  // ===== Shared landmark tables =====
  var OUTER_LIP = [61, 185, 40, 39, 37, 0, 267, 269, 270, 409, 291, 375, 321, 405, 314, 17, 84, 181, 91, 146];
  var INNER_LIP = [78, 191, 80, 81, 82, 13, 312, 311, 310, 415, 308, 324, 318, 402, 317, 14, 87, 178, 88, 95];
  var L_UP = [33, 246, 161, 160, 159, 158, 157, 173, 133], R_UP = [263, 466, 388, 387, 386, 385, 384, 398, 362];
  var L_LO = [33, 7, 163, 144, 145, 153, 154, 155, 133], R_LO = [263, 249, 390, 373, 374, 380, 381, 382, 362];
  // Perimeter landmark indices + per-point scale/offset for the foundation
  // face mask. Offsets are in canvas pixels, computed lazily per (w,h) below.
  var FOUNDATION_PERIM = [{ idx: 10, f: 1.10, lf: -0.07 }, { idx: 338, f: 1.10, lf: -0.06 }, { idx: 297, f: 1.08, lf: -0.05 }, { idx: 332, f: 1.07, lf: -0.04 }, { idx: 284, f: 1.06, lf: -0.03 }, { idx: 251, f: 1.07, lf: 0 }, { idx: 389, f: 1.07, lf: 0 }, { idx: 356, f: 1.07, lf: 0 }, { idx: 454, f: 1.07, lf: 0 }, { idx: 323, f: 1.06, lf: 0 }, { idx: 361, f: 1.05, lf: 0 }, { idx: 288, f: 1.05, lf: 0 }, { idx: 397, f: 1.05, lf: 0 }, { idx: 365, f: 1.04, lf: 0 }, { idx: 379, f: 1.04, lf: 0 }, { idx: 378, f: 1.03, lf: 0 }, { idx: 400, f: 1.03, lf: 0 }, { idx: 377, f: 1.03, lf: 0 }, { idx: 152, f: 1.05, lf: 0 }, { idx: 148, f: 1.03, lf: 0 }, { idx: 176, f: 1.03, lf: 0 }, { idx: 149, f: 1.03, lf: 0 }, { idx: 150, f: 1.04, lf: 0 }, { idx: 136, f: 1.04, lf: 0 }, { idx: 172, f: 1.05, lf: 0 }, { idx: 58, f: 1.05, lf: 0 }, { idx: 132, f: 1.05, lf: 0 }, { idx: 93, f: 1.06, lf: 0 }, { idx: 234, f: 1.07, lf: 0 }, { idx: 127, f: 1.07, lf: 0 }, { idx: 162, f: 1.07, lf: 0 }, { idx: 21, f: 1.06, lf: -0.03 }, { idx: 54, f: 1.06, lf: -0.04 }, { idx: 103, f: 1.08, lf: -0.05 }, { idx: 67, f: 1.10, lf: -0.06 }, { idx: 109, f: 1.10, lf: -0.07 }];
  var FOUNDATION_CUTOUTS = [L_UP.concat(L_LO.slice().reverse()), R_UP.concat(R_LO.slice().reverse()), OUTER_LIP];

  // Catmull-Rom point on a 4-point window — hoisted out of smoothLash's loop
  // so it's allocated once instead of once per sample point.
  function catmullRom(p0, p1, p2, p3, lt, axis) {
    var v0 = p0[axis], v1 = p1[axis], v2 = p2[axis], v3 = p3[axis];
    return 0.5 * ((2 * v1) + (-v0 + v2) * lt + (2 * v0 - 5 * v1 + 4 * v2 - v3) * lt * lt + (-v0 + 3 * v1 - 3 * v2 + v3) * lt * lt * lt);
  }
  function smoothLash(pts, N) {
    var out = [];
    for (var t = 0; t <= 1.0001; t += 1 / N) {
      var f = t * (pts.length - 1), i1 = Math.floor(f), i0 = Math.max(0, i1 - 1), i2 = Math.min(pts.length - 1, i1 + 1), i3 = Math.min(pts.length - 1, i1 + 2), lt = f - i1;
      out.push({ x: catmullRom(pts[i0], pts[i1], pts[i2], pts[i3], lt, 'x'), y: catmullRom(pts[i0], pts[i1], pts[i2], pts[i3], lt, 'y'), t: t });
    }
    return out;
  }

  function pathFromLandmarks(ctx, lm, indices, w, h) {
    indices.forEach(function (idx, j) {
      var p = lm[idx];
      if (j === 0) ctx.moveTo(p.x * w, p.y * h); else ctx.lineTo(p.x * w, p.y * h);
    });
  }

  function paintLipstick(ctx, lm, w, h, hex, coatFactor) {
    var alpha = Math.min(1, 0.72 * coatFactor);
    ctx.save();
    ctx.beginPath();
    pathFromLandmarks(ctx, lm, OUTER_LIP, w, h);
    ctx.closePath();
    INNER_LIP.slice().reverse().forEach(function (idx) { var p = lm[idx]; ctx.lineTo(p.x * w, p.y * h); });
    ctx.closePath();
    ctx.globalCompositeOperation = 'multiply'; ctx.globalAlpha = alpha; ctx.fillStyle = hex; ctx.fill('evenodd');
    ctx.globalCompositeOperation = 'soft-light'; ctx.globalAlpha = alpha * 0.22; ctx.fill('evenodd');
    ctx.restore();
  }

  function drawLiner(ctx, w, h, lm, upIdx, loIdx, color) {
    var up = upIdx.map(function (i) { return { x: lm[i].x * w, y: lm[i].y * h }; });
    var lo = loIdx.map(function (i) { return { x: lm[i].x * w, y: lm[i].y * h }; });
    var outer = up[0], inner = up[up.length - 1], ew = Math.hypot(inner.x - outer.x, inner.y - outer.y); if (ew < 5) return;
    var ox = (outer.x - inner.x) / ew, oy = (outer.y - inner.y) / ew;
    var upN = { x: -oy, y: ox }; if (upN.y > 0) { upN.x = -upN.x; upN.y = -upN.y; } var dnN = { x: -upN.x, y: -upN.y };
    var base = Math.max(1.3, ew * 0.016);
    var uPeak = base * 3.0, uMid = base * 2.0, uInner = base * 0.9, lThick = base * 1.2, wingLen = ew * 0.13, wingLift = ew * 0.07;
    var N = 28, upP = smoothLash(up, N), loP = smoothLash(lo, N);
    function upThick(t) { if (t > 0.78) { var k = (1 - t) / 0.22; return uInner + (uMid - uInner) * k; } var k2 = t / 0.78; return uPeak + (uMid - uPeak) * k2; }
    function loThick(t) { var fade = t > 0.7 ? Math.max(0, (1 - t) / 0.3) : 1; return lThick * (0.6 + 0.4 * fade); }
    var upBase = upP.map(function (p) { return { x: p.x, y: p.y }; });
    var upTop = upP.map(function (p) { var th = upThick(p.t); return { x: p.x + upN.x * th, y: p.y + upN.y * th }; });
    var loBase = loP.map(function (p) { return { x: p.x, y: p.y }; });
    var loBot = loP.map(function (p) { var th = loThick(p.t); return { x: p.x + dnN.x * th, y: p.y + dnN.y * th }; });
    var wingTip = { x: outer.x + ox * wingLen + upN.x * wingLift, y: outer.y + oy * wingLen + upN.y * wingLift };
    function bUp() { ctx.beginPath(); upBase.forEach(function (p, i) { i === 0 ? ctx.moveTo(p.x, p.y) : ctx.lineTo(p.x, p.y); }); for (var i = upTop.length - 1; i >= 0; i--) ctx.lineTo(upTop[i].x, upTop[i].y); ctx.lineTo(wingTip.x, wingTip.y); ctx.lineTo(outer.x, outer.y); ctx.closePath(); }
    function bLo() { ctx.beginPath(); loBase.forEach(function (p, i) { i === 0 ? ctx.moveTo(p.x, p.y) : ctx.lineTo(p.x, p.y); }); for (var i = loBot.length - 1; i >= 0; i--) ctx.lineTo(loBot[i].x, loBot[i].y); ctx.closePath(); }
    ctx.save(); ctx.lineJoin = "round"; ctx.lineCap = "round";
    ctx.save(); ctx.filter = "blur(" + (base * 1.4).toFixed(2) + "px)"; ctx.globalAlpha = 0.85; ctx.fillStyle = color; bUp(); ctx.fill(); bLo(); ctx.fill(); ctx.restore();
    ctx.globalAlpha = 1.0; ctx.fillStyle = color; bUp(); ctx.fill(); bLo(); ctx.fill();
    ctx.globalAlpha = 1.0; ctx.strokeStyle = color; ctx.lineWidth = Math.max(1, base * 0.7);
    ctx.beginPath(); upBase.forEach(function (p, i) { i === 0 ? ctx.moveTo(p.x, p.y) : ctx.lineTo(p.x, p.y); }); ctx.stroke();
    ctx.beginPath(); loBase.forEach(function (p, i) { i === 0 ? ctx.moveTo(p.x, p.y) : ctx.lineTo(p.x, p.y); }); ctx.stroke();
    ctx.restore();
  }
  function paintEyeliner(ctx, lm, w, h, hex) { drawLiner(ctx, w, h, lm, L_UP, L_LO, hex); drawLiner(ctx, w, h, lm, R_UP, R_LO, hex); }

  function init(root) {
    if (root.__vtoInit) return;
    root.__vtoInit = true;

    var dataEl = root.querySelector('[data-vto-data]');
    if (!dataEl) return;
    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { console.error('Colorbar VTO: bad data', e); return; }

    var overlay = root.querySelector('[data-vto-overlay]');
    var trigger = root.querySelector('[data-vto-trigger]');
    if (!overlay || !trigger) return;

    // Themes commonly animate section content with transform/filter/will-change,
    // which makes position:fixed resolve against that ancestor instead of the
    // viewport. Reparenting to <body> keeps the panel a true full-viewport overlay.
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);

    var canvas = overlay.querySelector('[data-canvas]');
    var placeholder = overlay.querySelector('[data-placeholder]');
    var swatchesEl = overlay.querySelector('[data-swatches]');
    var activeNameEl = overlay.querySelector('[data-active-shade]');
    var cta = overlay.querySelector('[data-add-to-cart]');
    var coatsEl = overlay.querySelector('[data-coats]');
    var uploadInput = overlay.querySelector('[data-upload-input]');
    var closeBtn = overlay.querySelector('[data-vto-close]');
    var video = overlay.querySelector('.colorbar-vto-video');
    var msgEl = overlay.querySelector('[data-msg]');

    var ctx = canvas.getContext('2d');
    var currentShade = null;
    var currentMode = null; // 'camera' | 'upload' | 'model'
    var stream = null;
    var imageEl = null;
    var landmarks = null;
    var coatFactor = 1.0;
    var faceMesh = null;
    var rafId = null;
    var missCount = 0;
    var fndMask = null, fndCol = null; // reused foundation scratch canvases
    var fndGeom = null; // cached {w,h,perim,cutouts} — rebuilt only when canvas size changes
    // Bumped every time the active mode/image changes, so a FaceMesh result that
    // resolves after the customer has already switched modes gets discarded
    // instead of being painted onto whatever is now on screen.
    var generation = 0;

    // ===== Open / close =====
    var prevFocus = null;
    function open() {
      prevFocus = document.activeElement;
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      trigger.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', onKeydown);
      closeBtn.focus();
    }
    function close() {
      overlay.hidden = true;
      document.body.style.overflow = '';
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);
      stopCamera();
      resetStage();
      if (prevFocus && prevFocus.focus) prevFocus.focus();
    }
    function onKeydown(e) { if (e.key === 'Escape' || e.key === 'Esc') close(); }

    // Return the stage to its "pick a mode" state so reopening always works.
    function resetStage() {
      generation++;
      placeholder.style.display = '';
      hideMsg();
      landmarks = null;
      imageEl = null;
      currentMode = null;
      missCount = 0;
      if (canvas.width && ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    function showMsg(t) { if (msgEl) { msgEl.textContent = t; msgEl.hidden = false; } }
    function hideMsg() { if (msgEl) msgEl.hidden = true; }

    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

    // ===== Build swatches =====
    DATA.shades.forEach(function (s) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'colorbar-vto-sw';
      btn.style.background = s.hex;
      btn.title = s.name;
      btn.setAttribute('aria-label', 'Shade ' + s.name);
      btn.addEventListener('click', function () {
        setShade(s);
        Array.prototype.forEach.call(swatchesEl.children, function (c) { c.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
      swatchesEl.appendChild(btn);
    });

    // Prices arrive as integer minor units; format against the shop currency rather
    // than hardcoding a symbol, so presentment currencies render correctly.
    function fmtPrice(cents) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: DATA.currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + DATA.currency;
      }
    }

    function setShade(s) {
      currentShade = s;
      activeNameEl.textContent = s.name;
      refreshCta();
      redraw();
    }

    function refreshCta() {
      var s = currentShade;
      if (!s) return;
      cta.disabled = !s.available;
      cta.textContent = s.available ? 'Add this shade — ' + fmtPrice(s.price) : 'Sold out';
    }

    // ===== Coats =====
    if (coatsEl) {
      coatsEl.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          coatsEl.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          coatFactor = parseFloat(b.dataset.coat);
          redraw();
        });
      });
    }

    // ===== Mode handlers =====
    overlay.querySelectorAll('[data-mode]').forEach(function (b) {
      b.addEventListener('click', function () {
        var mode = b.dataset.mode;
        if (mode === 'camera') startCamera();
        else if (mode === 'upload') uploadInput.click();
        else if (mode === 'model') useModel();
      });
    });
    uploadInput.addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0]; if (!f) return;
      loadImage(URL.createObjectURL(f), 'upload', true);
    });

    // ===== Camera =====
    function startCamera() {
      if (!navigator.mediaDevices) { alert('Camera not supported on this device.'); return; }
      stopCamera();
      var gen = ++generation;
      navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' }, audio: false })
        .then(function (s) {
          if (gen !== generation) { s.getTracks().forEach(function (t) { t.stop(); }); return; }
          stream = s; video.srcObject = s; currentMode = 'camera';
          placeholder.style.display = 'none';
          video.play()
            .then(function () { initFaceMeshThen(gen, function () { runVideoLoop(); }); })
            .catch(function () { showMsg('Could not start the camera preview.'); });
        })
        .catch(function (err) { alert('Could not access camera: ' + err.message); });
    }
    function stopCamera() {
      if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); stream = null; }
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      if (video) video.srcObject = null;
    }
    function runVideoLoop() {
      var sending = false; // never queue a frame while one is still in flight
      function tick() {
        if (!stream) return;
        if (video.readyState >= 2 && faceMesh && !sending) {
          canvas.width = video.videoWidth; canvas.height = video.videoHeight;
          sending = true;
          faceMesh.send({ image: video })
            .catch(function () { })
            .then(function () { sending = false; });
        }
        rafId = requestAnimationFrame(tick);
      }
      tick();
    }

    // ===== Upload / model =====
    function loadImage(src, mode, isBlob) {
      currentMode = mode || 'upload';
      stopCamera();
      placeholder.style.display = 'none';
      hideMsg();
      missCount = 0;
      var gen = ++generation;
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function () {
        if (gen !== generation) { if (isBlob) URL.revokeObjectURL(src); return; }
        if (isBlob) URL.revokeObjectURL(src);
        imageEl = img;
        canvas.width = img.naturalWidth; canvas.height = img.naturalHeight;
        initFaceMeshThen(gen, function () {
          faceMesh.send({ image: img }).catch(function () { });
        });
      };
      img.onerror = function () {
        if (isBlob) URL.revokeObjectURL(src);
        if (gen !== generation) return;
        imageEl = null;
        placeholder.style.display = '';
        showMsg(mode === 'model'
          ? 'This model photo is missing. Pick one in the theme editor under the Colorbar Try-On block settings.'
          : 'That image could not be loaded. Try a different photo.');
      };
      img.src = src;
    }
    function useModel() {
      if (!DATA.modelImage) { loadImage('', 'model'); return; }
      loadImage(DATA.modelImage, 'model');
    }

    // ===== FaceMesh init =====
    function initFaceMeshThen(gen, cb) {
      function ready() {
        if (gen !== generation) return;
        if (faceMesh) { cb(); return; }
        faceMesh = new FaceMesh({ locateFile: function (f) { return 'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh@0.4.1633559619/' + f; } });
        faceMesh.setOptions({ maxNumFaces: 1, refineLandmarks: true, minDetectionConfidence: 0.5, minTrackingConfidence: 0.5 });
        faceMesh.onResults(function (r) {
          if (gen !== generation) return; // stale result from a mode the customer already left
          if (r.multiFaceLandmarks && r.multiFaceLandmarks.length) {
            landmarks = r.multiFaceLandmarks[0];
            missCount = 0;
            hideMsg();
          } else {
            // Clear it, or the previous face's mesh keeps painting onto the new frame.
            landmarks = null;
            missCount++;
            // Debounced for video so a momentary dropout doesn't flash the message.
            if (missCount > (currentMode === 'camera' ? 15 : 0)) {
              showMsg('No face detected — try better lighting, or move closer to the camera.');
            }
          }
          redraw();
        });
        cb();
      }
      if (typeof FaceMesh !== 'undefined') { ready(); return; }

      // First use on this page: pull the engine down, keeping the customer informed.
      showMsg('Loading try-on…');
      window.__colorbarVTOLoadFaceMesh().then(function () {
        if (gen !== generation) return;
        hideMsg();
        ready();
      })['catch'](function () {
        if (gen !== generation) return;
        stopCamera();
        placeholder.style.display = '';
        showMsg('Try-on engine could not load. Check your connection and try again.');
      });
    }

    // ===== Render =====
    function redraw() {
      if (!ctx || !canvas.width) return;
      // For video, draw current video frame; for image, draw imageEl
      if (currentMode === 'camera' && video && video.readyState >= 2) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      } else if (imageEl && imageEl.complete) {
        ctx.drawImage(imageEl, 0, 0, canvas.width, canvas.height);
      } else {
        return;
      }
      if (!landmarks || !currentShade) return;

      if (DATA.productType === 'lipstick') paintLipstick(ctx, landmarks, canvas.width, canvas.height, currentShade.hex, coatFactor);
      else if (DATA.productType === 'eyeliner') paintEyeliner(ctx, landmarks, canvas.width, canvas.height, currentShade.hex);
      else if (DATA.productType === 'foundation') paintFoundation(canvas.width, canvas.height, landmarks, currentShade.hex);
    }

    // Foundation — face mask with soft-light blend. Geometry (perimeter +
    // cutout point lists) only depends on canvas size, so it's cached across
    // frames instead of rebuilt on every call — live camera repaints this
    // up to 60x/sec.
    function foundationGeometry(w, h) {
      if (fndGeom && fndGeom.w === w && fndGeom.h === h) return fndGeom;
      fndGeom = {
        w: w, h: h,
        perim: FOUNDATION_PERIM.map(function (p) { return { idx: p.idx, f: p.f, l: p.lf * h }; }),
        cutouts: FOUNDATION_CUTOUTS,
      };
      return fndGeom;
    }
    function paintFoundation(w, h, lm, hex) {
      var nose = lm[1], cx = nose.x * w, cy = nose.y * h;
      var geom = foundationGeometry(w, h);
      if (!fndMask) { fndMask = document.createElement('canvas'); fndCol = document.createElement('canvas'); }
      var mask = fndMask; if (mask.width !== w || mask.height !== h) { mask.width = w; mask.height = h; }
      var m = mask.getContext('2d'); m.clearRect(0, 0, w, h); m.globalCompositeOperation = 'source-over';
      m.fillStyle = '#fff'; m.beginPath();
      geom.perim.forEach(function (p, i) { var pt = { x: cx + (lm[p.idx].x * w - cx) * p.f, y: cy + (lm[p.idx].y * h - cy) * p.f + p.l }; i === 0 ? m.moveTo(pt.x, pt.y) : m.lineTo(pt.x, pt.y); });
      m.closePath(); m.fill();
      m.globalCompositeOperation = 'destination-out';
      geom.cutouts.forEach(function (region) { m.beginPath(); region.forEach(function (idx, j) { var pt = lm[idx]; j === 0 ? m.moveTo(pt.x * w, pt.y * h) : m.lineTo(pt.x * w, pt.y * h); }); m.closePath(); m.fill(); });
      var col = fndCol; if (col.width !== w || col.height !== h) { col.width = w; col.height = h; }
      var cc = col.getContext('2d'); cc.clearRect(0, 0, w, h); cc.globalCompositeOperation = 'source-over';
      cc.filter = 'blur(' + Math.max(6, w * 0.012) + 'px)'; cc.drawImage(mask, 0, 0); cc.filter = 'none';
      cc.globalCompositeOperation = 'source-in'; cc.fillStyle = hex; cc.fillRect(0, 0, w, h);
      ctx.save(); ctx.globalCompositeOperation = 'soft-light'; ctx.globalAlpha = 0.6; ctx.drawImage(col, 0, 0);
      ctx.globalCompositeOperation = 'multiply'; ctx.globalAlpha = 0.1; ctx.drawImage(col, 0, 0); ctx.restore();
    }

    // ===== Add to cart (Shopify AJAX cart API) =====
    cta.addEventListener('click', function () {
      if (!currentShade || !currentShade.available) return;
      cta.disabled = true; cta.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: currentShade.id, quantity: 1 }] })
      })
        .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw new Error(e.description || 'Add failed'); }); })
        .then(function () {
          cta.textContent = '✓ Added to cart';
          document.dispatchEvent(new CustomEvent('colorbar:vto:added', { detail: { shade: currentShade } }));
          // Re-derive from the current shade — the customer may have switched
          // shades during the success window.
          setTimeout(refreshCta, 1800);
        })
        .catch(function (err) {
          cta.textContent = 'Error — try again';
          console.error('Colorbar VTO add to cart failed', err);
          setTimeout(refreshCta, 2200);
        });
    });

    // Preselect first available shade for convenience
    var defShade = DATA.shades.find(function (s) { return s.available; }) || DATA.shades[0];
    if (defShade) {
      setShade(defShade);
      var firstSwatch = swatchesEl.children[DATA.shades.indexOf(defShade)];
      if (firstSwatch) firstSwatch.classList.add('is-active');
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-colorbar-vto-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  // Theme editor re-renders a section's HTML in place on every settings tweak;
  // re-scan just that section so a merchant editing block settings sees a live block.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
